import { useMutation } from '@apollo/client';
import createBroadcastChannel, {
  BroadcastChannels,
} from '@platform-ui-common/utilities/broadcastChannel.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import { useEffect } from 'react';
import EndSessionMutation from '../graphql/EndSessionMutation.graphql';

interface UseLogOutReturnProps {
  logout: () => void;
  loading: boolean;
}

export default function useLogout(): UseLogOutReturnProps {
  const [doLogout, { data, loading, error }] = useMutation<{
    authentication: { logout: { metadata: { status: number; errors: string[] } } };
  }>(EndSessionMutation);
  const logoutStatus = data?.authentication?.logout?.metadata?.status;
  const { user, identity } = useAuth();

  useEffect(() => {
    const logoutChannel = createBroadcastChannel(BroadcastChannels.Logout);
    if (logoutStatus === 200) logoutChannel.postMessage('logout');

    const errorResponse = data?.authentication?.logout?.metadata?.errors?.toString();
    if (error || data?.authentication?.logout?.metadata?.status > 200) {
      const errorMessage = error?.message ?? errorResponse ?? 'Something went wrong!';
      throw new Error(errorMessage);
    }
  }, [data, logoutStatus, error]);

  const logout = async () => {
    if (user?.gcip || user?.core) {
      await doLogout();
      localStorage.clear();
      sessionStorage.clear();
      await identity?.auth?.signOut();
      window.location.reload();
    } else {
      window.location.reload();
    }
  };

  return {
    logout,
    loading,
  };
}
